import React from 'react';
import { Alert, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { OCRErrorLog } from 'types';


interface OCRErrorAlertProps {
  ocrErrorLogs: OCRErrorLog[];
  showOcrErrors: boolean;
  onClear: () => void;
}

export const OCRErrorAlert: React.FC<OCRErrorAlertProps> = ({
  ocrErrorLogs,
  showOcrErrors,
  onClear,
}) => {
  if (!showOcrErrors || ocrErrorLogs.length === 0) return null;

  return (
    <Alert
      message="Some CVs were not processed"
      description={
        <div>
          <p>
            These files were skipped because they exceed 1MB or are not a supported
            type. Readable CVs go to standard Smart Screen; image or unreadable CVs
            are sent through OCR instead of being skipped.
          </p>
          <div className="mt-2 max-h-40 overflow-y-auto">
            {ocrErrorLogs.map((log, index) => (
              <div key={index} className="text-sm border-b py-1">
                <strong>{log.fileName}</strong>
              </div>
            ))}
          </div>
        </div>
      }
      type="warning"
      showIcon
      icon={<ExclamationCircleOutlined />}
      closable
      onClose={onClear}
      action={
        <Button size="small" onClick={onClear}>
          Clear
        </Button>
      }
    />
  );
};